import { createApi } from '@reduxjs/toolkit/query/react';
import { btBaseQuery } from 'src/Common/common';

// Define a service using a base URL and expected endpoints
export const aceincomesApi = createApi({
  reducerPath: 'aceincomesApi',
  baseQuery: btBaseQuery,
  tagTypes: ['ACEIncomes'],

  endpoints: (builder) => ({
    getACEIncomess: builder.query<ac_eincomes[], string>({
      query: (cid) => `aceincomes/${cid}`,
      providesTags: ['ACEIncomes']
    }),
    getACEIncomes: builder.query<ac_eincomes, string>({
      query: (id) => `aceincomes/byid/${id}`
    }),
    insertACEIncomes: builder.mutation({
      query: (aceincomes) => ({
        url: `aceincomes/`,
        method: 'POST',
        body: aceincomes
      }),
      invalidatesTags: ['ACEIncomes']
    }),
    updateACEIncomes: builder.mutation({
      query: (aceincomes) => ({
        url: `aceincomes/`,
        method: 'PUT',
        body: aceincomes
      }),
      invalidatesTags: ['ACEIncomes']
    }),
    deleteACEIncomes: builder.mutation({
      query: (aceincomes) => ({
        url: `aceincomes/${aceincomes.ic_id}`,
        method: 'DELETE',
        body: aceincomes
      }),
      invalidatesTags: ['ACEIncomes']
    })
  })
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetACEIncomessQuery,
  useGetACEIncomesQuery,
  useInsertACEIncomesMutation,
  useUpdateACEIncomesMutation,
  useDeleteACEIncomesMutation
} = aceincomesApi;
